export default __webpack_public_path__ + "static/media/helpful-resources-mobile@2x.28c04cfc.webp";